<tp-marketplace-integration providerName="AWS" [isSubmitting$]="isSubmitting$" (setAccount)="setAWSAccount($event.team, $event.token)"/>
